import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import User from "../../User/User";
import Menu from "./SideBarMenu";

import LogService from "../../../middleware/CommonSdk/LogService";
import * as ContactUtils from "../../Utils/ContactUtils";

const LOG_TAG = "JSX:SIDEBAR";

const Sidebar = (props) => {

    LogService.info(LOG_TAG, "render");

    const userName = ContactUtils.getDisplayName(props.user);
    const companyName = ContactUtils.getCompanyName(props.user);
    const avatar = ContactUtils.getAvatar(props.user);

    return (
        <nav id="sidebar" className={props.status ? "sidebar toggled" : "sidebar"}>
            <div className="sidebar-content">

                <User
                    name={userName}
                    title={companyName}
                    avatar={avatar}
                />

                <Menu
                    isAuthenticated={props.user != null}
                    isDeveloper={ContactUtils.isDeveloper(props.user)}
                    isSuperAdminOrAppSuperAdmin={ContactUtils.isSuperAdminOrAppSuperAdmin(props.user)}
                    isSupportOrAppSupport={ContactUtils.isSupportOrAppSupport(props.user)}
                />
            </div>
        </nav>
    );
};

Sidebar.propTypes = {
    status: PropTypes.bool,
    user: PropTypes.object,
};

Sidebar.defaultProps = {
    status: false,
    user: null
}

export default injectIntl(Sidebar)